import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccount  {
    _originalTypeClassName = "zERP.BO.CashAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccount.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Name = null;
this.Code = null;
this.Balance = null;
this.SeriesCode = null;
this.SkipBalanceCheck = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Code:any;
Balance:any;
SeriesCode:any;
SkipBalanceCheck:any;
Entity:any;
Currency:any;
AccountingConfig:any;
Series:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
if (oldValue != null) {
Domain.BusinessEntity.removeCashAccounts(oldValue, $this);
}
Domain.BusinessEntity.addCashAccounts(value, $this);
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}

static GetClassName(): any{return "CashAccount";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}